// Import styles directly instead of adding it later for CSP
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import * as Sentry from "@sentry/react";
import { NODE_ENV, REACT_APP_SENTRY_DSN } from "environmentVariables";
config.autoAddCss = false;

export declare let __webpack_nonce__: string;
// eslint-disable-next-line
__webpack_nonce__ = (window as any).NONCE;
(window as any).__webpack_nonce__ = (window as any).NONCE;

Sentry.init({ environment: NODE_ENV, dsn: REACT_APP_SENTRY_DSN });
